import { createMeetingParticipant } from '../../factories/meeting-participant';
export const SKELETON_PARTICIPANT = [
    createMeetingParticipant({
        id: '0',
        user_id: '0',
        first_name: '-',
        last_name: '-',
        created: new Date('2022-04-03T13:24:00'),
        updated: new Date('2022-04-03T13:24:00'),
        meeting: 'meeting',
        role: {
            id: '0',
            role: '-',
            intranet_id: 0,
        },
        fonction: 'Chef',
        structure_principale: {
            id: '0',
            label: '-',
            structure_code: '0000',
            structure_echelon: '',
            structure_type: '',
        },
        daily_task_team: {
            id: '0',
            label: 'Equipe 0',
            meeting: 'meeting',
            color: '#00bfff',
        },
        teams: [],
        track: {
            id: '0',
            label: '',
            meeting: '',
        },
        track_id: '0',
        avatar_url: '',
        signature_url: '',
    }, {
        fonction_code: '210',
        fonction: "RESPONSABLE D'UNITE LOUVETEAU JEANNETTE",
    }),
    createMeetingParticipant({
        id: '1',
        user_id: '1',
        first_name: '-',
        last_name: '-',
        created: new Date('2022-02-02T20:35:56.575249Z'),
        updated: new Date('2022-04-03T13:24:56.575249Z'),
        meeting: 'meeting',
        role: {
            id: '0',
            role: '-',
            intranet_id: 0,
        },
        fonction: 'Chef',
        structure_principale: {
            id: '0',
            label: '-',
            structure_code: '0000',
            structure_echelon: '',
            structure_type: '',
        },
        daily_task_team: {
            id: '0',
            label: 'Equipe 0',
            meeting: 'meeting',
            color: '#00bfff',
        },
        teams: [],
        track: {
            id: '0',
            label: '',
            meeting: '',
        },
        track_id: '0',
        avatar_url: '',
        signature_url: '',
    }, {
        fonction_code: '210',
        fonction: "RESPONSABLE D'UNITE LOUVETEAU JEANNETTE",
    }),
];
//# sourceMappingURL=participant.utils.js.map